/**
 * Diolo launch gate — the storefront browses but does not sell before
 * this instant (Hayden, 2026-09-01: "people cant buy yet… launch is on 9/9").
 *
 * 9 pm Vietnam time, 9 September 2026 (Hayden 2026-09-06: "launch is 9pm Vietnam
 * time" — evening, when people are on their phones; the list's door opened the
 * evening before, so the two are a clean day apart). Date-based on purpose: the
 * store opens itself at launch with no deploy. Enforced in TWO places —
 * the PDP add-to-bag buttons (UI) and the checkout action (server, the
 * one that matters). After 9/9 this becomes dead code; safe to strip.
 */
export const LAUNCH_AT = new Date("2026-09-09T21:00:00+07:00");

export const isPreLaunch = () => Date.now() < LAUNCH_AT.getTime();

export const launchLabel = (locale: string) =>
  locale === "vi" ? "DIOLO 001 — mở bán 09.09, 21:00" : "DIOLO 001 — launching 09.09 at 9 pm";

// ─── Pre-launch takeover ────────────────────────────────────────────────
// Before LAUNCH_AT every storefront route redirects to /001 (the teaser)
// unless the visitor carries the preview cookie set by /access?k=<key>.
// The key is a soft gate for Hayden, Court Test players and the early-
// access list — not a security boundary.
export const PREVIEW_COOKIE = "diolo_access";
export const previewKey = () => process.env.LAUNCH_PREVIEW_KEY || "diolo-preview";
/** The list's early-access key (emailed 08.09 at 9 pm). Separate from Hayden's so it can be rotated on its own. */
export const earlyAccessKey = () => process.env.LAUNCH_EARLY_KEY || "";
export const isAccessKey = (k: string | null | undefined) =>
  !!k && (k === previewKey() || (!!earlyAccessKey() && k === earlyAccessKey()));
export const hasPreviewAccess = (cookieHeader: string | null | undefined) => {
  if (!cookieHeader) return false;
  const m = cookieHeader.match(/(?:^|;\s*)diolo_access=([^;]+)/);
  return !!m && isAccessKey(decodeURIComponent(m[1]));
};

/**
 * Can this visitor buy right now? Everyone after 21:00 on 09.09; before that
 * only holders of the preview / early-access cookie — the early-access email
 * promises "yours opens now", and a test order has to be possible before the
 * public open. Used by the PDP buy buttons and the checkout action.
 */
export const isSellable = (cookieHeader: string | null | undefined) =>
  !isPreLaunch() || hasPreviewAccess(cookieHeader);
